export const getLastRecorderAudioChunk = async (
	audioBlob: Blob,
	lastProcessedPosition: number = 0,
	createWAVFromAudioBuffer: (audioBuffer: AudioBuffer) => ArrayBuffer,
): Promise<{ wavBlob: Blob; newAudioEndPosition: number }> => {
	const arrayBuffer = await audioBlob.arrayBuffer();
	const audioContext = new AudioContext();

	try {
		const audioBuffer = await audioContext.decodeAudioData(arrayBuffer);
		const totalSamples = audioBuffer.length;
		const newSamples = totalSamples - lastProcessedPosition;

		if (newSamples <= 0) {
			await audioContext.close();
			return { wavBlob: new Blob([], { type: 'audio/wav' }), newAudioEndPosition: 0 };
		}

		const newAudioStart = lastProcessedPosition;
		const newAudioEndPosition = totalSamples;
		const newAudioLength = newAudioEndPosition - newAudioStart;

		const newAudioBuffer = audioContext.createBuffer(
			audioBuffer.numberOfChannels,
			newAudioLength,
			audioBuffer.sampleRate,
		);

		for (let channel = 0; channel < audioBuffer.numberOfChannels; channel++) {
			const channelData = audioBuffer.getChannelData(channel);
			const newChannelData = newAudioBuffer.getChannelData(channel);
			newChannelData.set(channelData.slice(newAudioStart, newAudioEndPosition));
		}

		const wavBuffer = createWAVFromAudioBuffer(newAudioBuffer);
		const wavBlob = new Blob([wavBuffer], { type: 'audio/wav' });

		await audioContext.close();
		return { wavBlob, newAudioEndPosition };
	} catch (error) {
		await audioContext.close();
		throw error;
	}
};
